import AxiosClient from '../../repositories/clients/axios'
import messages from '../../constants'
import { Order } from '../../entity/Order'
import { redirectInvalidUser } from '../../functions'
import router from '../../router'

export default {
  namespaced: true,
  state: {
    list: null,
    limit: 4,
    page: 1,
    quantityPage: 0,
    currentPage: 1,
    error: null,
    loading: true,
    status: '',
    showPagination: false,
    pagination: {}
  },
  mutations: {
    setLoading (state, value) {
      state.loading = value
    },
    setOrders (state, order) {
      state.list = order
    },
    setError (state, error) {
      state.error = error
    },
    nextPage (state) {
      state.page++
      state.currentPage++
    },
    prevPage (state) {
      if (state.page >= 1) {
        state.page--
        state.currentPage--
      }
    },
    page (state, page) {
      state.page = page
    },
    setStatus (state, value) {
      state.status = value || 'opened'
    },
    setShowPagination (state, value) {
      state.showPagination = value
    },
    setPagination (state, value) {
      state.pagination = value
    }
  },
  actions: {
    async loadOrders (context) {
      try {
        context.commit('setOrders', [])
        context.commit('setLoading', true)
        context.commit('setError', null)
        context.commit('setShowPagination', false)
        context.commit('setPagination', {})

        const response = await AxiosClient(true).get(process.env.VUE_APP_PANEL_ORDERS, {
          params: {
            page: context.state.page,
            status: context.state.status || 'opened',
            limit: context.state.limit
          }
        })
        if (response.data && response.data.code === 401) {
          redirectInvalidUser()
          return
        }
        let messageError = messages.NO_ORDERS
        switch (context.state.status) {
          case 'opened':
            messageError = { open: messages.NO_ORDERS_OPENED }
            break
          case 'closed':
            messageError = messages.NO_ORDERS_CLOSED
            break
        }
        const data = response.data
        if (!data || !data.orders || data.orders.length === 0) {
          throw { data: messageError }
        }

        const orders = data.orders.map(element => new Order(element))

        context.commit('setOrders', orders)
        context.dispatch('formatPagination', data.page)
      } catch (error) {
        let errorMessage = messages.ERROR_AWAIT
        if (error && error.data) {
            errorMessage = error.data
        } else if (error.response && error.response.status === 404) {
            errorMessage = messageError
        }

        if (error.response && error.response.status === 401) {
          redirectInvalidUser()
        }
        context.commit('setError', errorMessage)
        
    } finally {
        context.commit('setLoading', false)
    }
},
    changeStatusOrder (context, value) {
      context.commit('page', 1)
      context.commit('setStatus', value)
      router.push({
        name: 'orders',
        query: {
          page: context.state.page,
          filter: context.state.status || 'opened'
        }
      }).catch(() => {})
      context.dispatch('loadOrders')
    },
    loadNextPage (context) {
      if (context.state.pagination.page >= context.state.pagination.pages) {
        return
      }

      context.commit('nextPage')

      router.push({
        name: 'orders',
        query: {
          page: context.state.page,
          filter: context.state.status || 'opened'
        }
      }).catch(() => {})

      context.dispatch('loadOrders')
    },
    loadPrevPage (context) {
      if (context.state.pagination.page == 1) {
        return
      }

      context.commit('prevPage')

      router.push({
        name: 'orders',
        query: {
          page: context.state.page,
          filter: context.state.status || 'opened'
        }
      }).catch(() => {})

      context.dispatch('loadOrders')
    },
    setPage (context, value) {
      context.commit('page', value != null ? value : 1)

      router.push({
        name: 'orders',
        query: {
          page: context.state.page,
          filter: context.state.status || 'opened'
        }
      }).catch(() => {})

    },
    changeStatus (context, value) {
      context.commit('setStatus', value != null ? value : context.state.status || 'opened')
    },
    setLoading (context, value) {
      context.commit('setLoading', value)
    },
    formatPagination (context, value) {
      if (value.pages > 1) {
        context.commit('setShowPagination', true)

        const current = value.page
        const last = value.pages
        const delta = 2
        const left = current - delta
        const right = current + delta + 1
        const range = []
        const rangeWithDots = []
        let keyRange

        for (let i = 1; i <= last; i++) {
          if (i == 1 || i == last || i >= left && i < right) {
            range.push(i)
          }
        }

        for (const i of range) {
          if (keyRange) {
            if (i - keyRange === 2) {
              rangeWithDots.push(keyRange + 1)
            } else if (i - keyRange !== 1) {
              // rangeWithDots.push('...');
            }
          }
          rangeWithDots.push(i)
          keyRange = i
        }
        value.listPage = rangeWithDots
        context.commit('setPagination', value)
      }
    }
  },
  getters: {
    getPage: state => {
      return state.page
    }
  }
}
